import React from "react";
import { useTranslation } from "@/i18n/I18nProvider";

export default function Privacy() {
  const { t, dict } = useTranslation();
  const sections = dict.privacy?.sections || [];
  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <p className="text-xs uppercase tracking-[0.24em] font-semibold text-blue-900 mb-3">
          {t("privacy.updated")}
        </p>
        <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          {t("privacy.title")}
        </h1>
        <p className="text-slate-600 leading-relaxed mt-6">{t("privacy.intro")}</p>
        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="text-xl font-semibold text-slate-900">{s.heading}</h2>
              <p className="text-slate-600 leading-relaxed mt-2">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
